import { Footer } from '@tt/design-system';
import type { ReactNode } from 'react';
import { SiteHeader } from '../components/SiteHeader';

type PublicLayoutProps = {
  children: ReactNode;
};

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <>
      <SiteHeader variant="public" />
      <main id="main" className="min-h-[80vh] bg-night text-parchment">
        {children}
      </main>
      <Footer />
    </>
  );
}
